import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";
import "./i18n";
import { applyDbTranslationOverrides } from "./lib/dbTranslations";
import { applyDesignTokenOverrides } from "./lib/designTokens";

// Apply admin-edited overrides on app boot (non-blocking)
applyDbTranslationOverrides();
applyDesignTokenOverrides();

// Unregister service workers in iframe/preview contexts to prevent stale cache issues
const isInIframe = (() => {
  try {
    return window.self !== window.top;
  } catch {
    return true;
  }
})();

const isPreviewHost =
  window.location.hostname.includes("id-preview--") ||
  window.location.hostname.includes("lovableproject.com");

if (isPreviewHost || isInIframe) {
  navigator.serviceWorker?.getRegistrations().then((registrations) => {
    registrations.forEach((r) => r.unregister());
  });
}

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>,
);
